export const createMentionId = (id: string, email: string, name: string): string => {
  return `${id}-${email}-${name}`;
};

export const extractNameFromMentionId = (id: string): string => {
  const lastDashIndex = id.lastIndexOf('-');
  if (lastDashIndex === -1) return id;
  return id.substring(lastDashIndex + 1);
};

export const extractEmailFromMentionId = (id: string): string => {
  const lastDashIndex = id.lastIndexOf('-');
  if (lastDashIndex === -1) return id;
  return id.substring(0, lastDashIndex);
};
